import { render, staticRenderFns } from "./iconWarning.vue?vue&type=template&id=44be0443&scoped=true"
import script from "./iconWarning.vue?vue&type=script&lang=js"
export * from "./iconWarning.vue?vue&type=script&lang=js"
import style0 from "./iconWarning.vue?vue&type=style&index=0&id=44be0443&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44be0443",
  null
  
)

export default component.exports